// tagmin requirement clean up midnight hour

export function clearStartOfTheDay(hour: string) {
  return hour === "0:00" ? "" : hour;
}
